const $ = require('jquery') 
const Comments = require('../components/comments.js') 
var GlobalPaginate = {
    defaultPage : 2,
    loading : false,
    init : function () {
        this.loadArticleByCategories()
        this.runToken()
        this.fixAds()
        this.nextTabHome()
        this.scrollAndConvertContent()
    },
    scrollAndConvertContent()
    {
        $(window).bind('scroll', function () {
            if ($(this).scrollTop() > 100) {
                $('.js-backTop').fadeIn(400);
            } else {
                $('.js-backTop').fadeOut(400);
            }
        });
        $('.js-backTop').click(function(){
            $('html, body').animate({scrollTop: '0px'}, 1000);
        });
        // let elementArray = [
        //     'div','span','p'
        // ]
        // elementArray.map(function (element) {
        //     $(element).attr('contenteditable','false');
        // })
    },

    runToken() {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
    },
}

$(function () {
    // GlobalPaginate.init()
    // CountViewArticle.init()
    Comments.init()
    // AddClassIframe.init()
})
